<template lang="pug">
div.is-flex.is-flex-direction-column.is-fullheight
  header.modal-card-head
    
    p.modal-card-title.is-size-5(data-qa="modal-header") 
      b(v-t="'ledger.cash_register_title'")
      //- span.px-3 | 
      //- b.has-text-success(v-if="session && !session.close") {{$t('ledger.status_open')}}
      //- b.has-text-danger(v-else) {{$t('ledger.status_closed')}}
      template(v-if="hasMultipleLocations") 
        span.pl-3.pr-2.is-size-6 |
          span.icon
            i.mdi.mdi-map-marker-outline 
          location-view(:value="user.location")
    div
      a.button.is-white.is-small(@click="$emit('close')")
        span.icon
          i.mdi.mdi-close.mdi-24px
  em-loading(:active="loading" :is-full-page="false")
  div(v-if="!session && !loading")
    .hero.is-medium
      .hero-body.has-text-centered
        span.icon.is-large
          i.mdi.mdi-clipboard-list-outline.mdi-36px
        h3.title.is-5(v-t="'ledger.start_title'")
        p.subtitle.is-6(v-t="'ledger.start_subtitle'")
        .buttons.is-centered
          button.button.is-primary(@click="openCloseRegister" v-t="'ledger.actions.start'" :disabled="!$rfHasPermission('CASH_REGISTER_MANAGE')") 
  
  .has-background-white(v-else-if="session")
    .p-5
      div
        .buttons
          button.button.is-dark(@click="registerExpense" :disabled="!$rfHasPermission('CASH_REGISTER_MANAGE')") 
            span.icon
              i.mdi.mdi-arrow-up-bold-box-outline
            span {{$t('ledger.actions.expense')}}
          router-link.button.is-ghost(:to="{name: 'Reports', query: {report: 'pAndL'}}" style="margin-left: auto;")
            span.icon
              i.mdi.mdi-chart-box-outline
            span {{$t('ledger.actions.view_pl_report')}}
        hr
        .list.p-2.mb-5
          .list-item
            .level.is-mobile
              .level-item.is-justify-content-left
                div
                  p.is-size-8.has-text-grey 
                    small {{$t('ledger.status_label')}}
                  h3.is-size-5.has-text-weight-bold.has-text-success(v-if="!session.close") {{$t('ledger.status_open')}}
                  h3.is-size-5.has-text-weight-bold.has-text-danger(v-else) {{$t('ledger.status_closed')}}
                  
                  
              .level-item.is-justify-content-right
                div
                  button.button.is-success(v-if="session.close" @click="openCloseRegister" v-t="'actions.open'" :disabled="!$rfHasPermission('CASH_REGISTER_MANAGE')")
                  button.button.is-danger(v-else @click="openCloseRegister" v-t="'ledger.actions.close_day'" :disabled="!$rfHasPermission('CASH_REGISTER_MANAGE')")
            
            //.level
              .level-right
                .level-item.is-justify-content-right
                  div
                    //p.heading Operation
                    button.button.is-success(v-if="session.close" @click="openCloseRegister" v-t="'actions.open'" :disabled="!$rfHasPermission('CASH_REGISTER_MANAGE')")
                    button.button.is-danger(v-else @click="openCloseRegister" v-t="'ledger.actions.close_day'" :disabled="!$rfHasPermission('CASH_REGISTER_MANAGE')")
                .level-item
                  .buttons
                    button.button(@click="openTransactions") 
                      span.icon
                        i.mdi.mdi-format-list-bulleted
                      span {{$t('ledger.actions.view_transaction')}}
                    button.button(@click="openSessionHistory") 
                      span.icon
                        i.mdi.mdi-cash-register
                      span {{$t('ledger.actions.view_session_history')}}
        
        
        template(v-if="balance")
          .mb-5
            p.title.is-6.mb-2(v-t="'ledger.balance_header'")
            .list.p-2
              .list-item
                .level.is-mobile
                  .level-item.is-justify-content-left
                    div
                      p.heading(v-t="'ledger.cash_float'")
                      h3.title.is-6 
                        currency-view(:value="session.openBalance")
                  .level-item.is-justify-content-left
                    div
                      p.heading(v-t="'ledger.current_balance'")
                      h3.title.is-6 
                        currency-view(:value="session.openBalance + balance.in.total - balance.out.total")
                  .level-item.is-justify-content-left
                    div
                      p.heading(v-t="'ledger.net_income'")
                      h3.title.is-6 
                        currency-view(:value="balance.in.total - balance.out.total")
          .mb-5(v-if="session.openDifference || session.closeDifference")
            p.title.is-6.mb-2
              span(v-t="'ledger.deficit_header'")
              span.icon.has-text-danger
                i.mdi.mdi-alert-circle-outline
            .columns
              .column(v-if="session.openDifference")
                .notification.is-white.has-border-all.has-border-danger.p-4
                  p.heading.has-text-danger.has-text-weight-semibold(v-if="session.openDifference > 0" v-t="'ledger.float_surplus'")
                  p.heading.has-text-danger.has-text-weight-semibold(v-else v-t="'ledger.float_deficit'")
                  h3.title.is-6
                    currency-view(:value="session.openDifference")
              .column(v-if="session.closeDifference")
                .notification.is-white.has-border-all.has-border-danger.p-4
                  p.heading.has-text-danger.has-text-weight-semibold(v-if="session.closeDifference > 0" v-t="'ledger.end_of_day_surplus'")
                  p.heading.has-text-danger.has-text-weight-semibold(v-else v-t="'ledger.end_of_day_deficit'")
                  h3.title.is-6
                    currency-view(:value="session.closeDifference")
          
          .buttons.is-centered
            button.button.is-success(@click="registerCashIn" :disabled="!session || session.close || !$rfHasPermission('CASH_REGISTER_MANAGE')") 
              span.icon
                i.mdi.mdi-arrow-down-bold-box-outline
              span {{$t('ledger.actions.cash_in')}}
            
          
            button.button.is-warning(@click="cashOut" :disabled="!session || session.close || !$rfHasPermission('CASH_REGISTER_MANAGE')") 
              span.icon
                i.mdi.mdi-arrow-up-bold-box-outline
              span {{$t('ledger.actions.cash_out')}}
            
            
          .list
            b-collapse(:open="false")
              template(slot="trigger" slot-scope="{open}")
                .is-flex.is-align-items-center.list-item.has-border-bottom.pl-1
                  .is-flex-grow-1
                    
                    h3.title.is-6.m-0 
                      span.icon
                        i.mdi.mdi-chevron-right(v-if="!open")
                        i.mdi.mdi-chevron-down(v-else)
                      | {{$t('ledger.cash_in_heading')}}
                  .is-flex-shrink-0
                    h3.title.is-6.m-0
                      currency-view(:value="balance.in.total")
                  //button.button.is-success(@click="registerCashIn" :disabled="!session || session.close || !$rfHasPermission('CASH_REGISTER_MANAGE')") 
                    span.icon
                      i.mdi.mdi-arrow-down-bold-box-outline
                    span {{$t('ledger.actions.cash_in')}}
              //.list
              .list-item.is-size-6
                span {{$t('register_transactions.sale')}}
                span.is-pulled-right
                  strong  
                    currency-view(:value="balance.in.sale")
              .list-item.is-size-6
                span.has-text-grey.pl-3 {{$t('register_transactions.sale_card')}}
                span.is-pulled-right
                  span  
                    currency-view(:value="balance.noncash.card")
              .list-item.is-size-6
                span.has-text-grey.pl-3 {{$t('register_transactions.point_redeems')}}
                span.is-pulled-right
                  span  
                    currency-view(:value="balance.noncash.points")
              .list-item.is-size-6
                span.has-text-grey.pl-3 {{$t('register_transactions.voucher_redeems')}}
                span.is-pulled-right
                  span  
                    currency-view(:value="balance.noncash.voucher")
              .list-item.is-size-6
                span.has-text-grey.pl-3 {{$t('register_transactions.other_non_cash')}}
                span.is-pulled-right
                  span  
                    currency-view(:value="balance.noncash.other")
              
              .list-item.is-size-6
                span {{$t('register_transactions.tip')}}
                span.is-pulled-right
                  strong  
                    currency-view(:value="0")
              //.list-item.is-size-6
                span Sales non cash
                span.is-pulled-right
                  strong  
                    currency-view(:value="342")
              //.list-item.is-size-6
                span Sales total
                span.is-pulled-right
                  strong  
                    currency-view(:value="342")
              .list-item.is-size-6
                span {{$t('register_transactions.return')}}
                span.is-pulled-right
                  strong  
                    currency-view(:value="balance.in.return + balance.in.change")
              .list-item.is-size-6.has-border-bottom
                span {{$t('register_transactions.addition')}}
                span.is-pulled-right
                  strong  
                    currency-view(:value="balance.in.addition")
              //.list-item.is-size-6
                strong {{$t('ledger.total_in_label')}}
                span.is-pulled-right
                  strong  
                    currency-view(:value="balance.in.total")
            

          
            b-collapse(:open="false")
              template(slot="trigger" slot-scope="{open}")
                .is-flex.is-align-items-center.list-item.pl-1
                  .is-flex-grow-1
                    h3.title.is-6.m-0 
                      span.icon
                        i.mdi.mdi-chevron-right(v-if="!open")
                        i.mdi.mdi-chevron-down(v-else)
                      | {{$t('ledger.cash_out_heading')}}
                  .is-flex-shrink-0
                    h3.title.is-6.m-0
                      currency-view(:value="balance.out.total")
              
              //.list
              .list-item.is-size-6
                span {{$t('register_transactions.expense')}}
                span.is-pulled-right
                  strong  
                    currency-view(:value="balance.out.expense")
              .list-item.is-size-6
                span {{$t('register_transactions.stock')}}
                span.is-pulled-right
                  strong  
                    currency-view(:value="balance.out.stock")
              .list-item.is-size-6
                span {{$t('register_transactions.out')}}
                span.is-pulled-right
                  strong  
                    currency-view(:value="balance.out.out")
              .list-item.is-size-6
                span {{$t('register_transactions.refund')}}
                span.is-pulled-right
                  strong  
                    currency-view(:value="balance.out.refund")
              .list-item.is-size-6(v-if="company.registerCommissions")
                span {{$t('register_transactions.payout')}}
                span.is-pulled-right
                  strong  
                    currency-view(:value="balance.out.payout")
              //.list-item.is-size-6
                strong {{$t('ledger.total_out_label')}}
                span.is-pulled-right
                  strong  
                    currency-view(:value="balance.out.total")
    .p-5.has-background-light
      .py-2.buttons.is-centered
        button.button.is-light(@click="openTransactions") 
          span.icon
            i.mdi.mdi-format-list-bulleted
          span {{$t('ledger.actions.view_transaction')}}
        button.button.is-light(@click="openSessionHistory") 
          span.icon
            i.mdi.mdi-cash-register
          span {{$t('ledger.actions.view_session_history')}}
      h4.is-size-6.mb-4.has-text-centered.has-text-grey {{$t('ledger.session_details')}}
      .level.is-mobile
        .level-item.is-justify-content-center
          div.has-text-centered
            p.heading.is-size-8 {{$t('ledger.opened_by')}}
            h3.is-size-7.mb-1.has-text-grey-dark
              staff-view(:id="session.openBy")
            p.subtitle.is-7.has-text-grey
              em
                date-view(:value="session.open" format="LL LT")
        .level-item.is-justify-content-center(v-if="session.close")
          div.has-text-centered
            p.heading.is-size-8 {{$t('ledger.closed_by')}}
            h3.is-size-7.mb-1.has-text-grey
              staff-view(:id="session.closeBy")
            p.subtitle.is-7.has-text-grey
              em
                date-view(:value="session.close" format="LL LT")

      //.column.is-6
        h3.title.is-5 Payouts
</template>
<script>
import {mapActions, mapGetters, mapState} from 'vuex'

import OpenCloseRegister from './OpenCloseRegister'

import Transactions from './Transactions'
import CashIn from './CashIn'
import CashOut from './CashOut'
import Expense from './Expense'
import SessionHistory from './SessionHistory'

export default {
  name: 'CashRegister',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('ledger', ['session', 'balance']),
    ...mapState('company', ['company']),
    ...mapGetters('location', ['hasMultipleLocations'])
  },
  async created() {
    try {
      this.loading = true
      await Promise.all([this.fetchSession(), this.fetchBalance()])
    } catch (err) {
      this.$handleAPIError(err)
    }
    this.loading = false
  },
  methods: {
    ...mapActions('ledger', ['fetchSession', 'fetchBalance']),

    openCloseRegister() {
      this.$buefy.modal.open({
        parent: this,
        component: OpenCloseRegister,
        hasModalCard: true,
        canCancel: ['escape', 'outside']
      })
    },

    openTransactions() {
      this.$buefy.modal.open({
        parent: this,
        component: Transactions,
        hasModalCard: true,
        width: 960,
        canCancel: ['escape', 'outside']
      })
    },
    openSessionHistory() {
      this.$buefy.modal.open({
        parent: this,
        component: SessionHistory,
        hasModalCard: true,
        width: 960,
        canCancel: ['escape', 'outside']
      })
    },
    registerCashIn() {
      this.$buefy.modal.open({
        parent: this,
        component: CashIn,
        hasModalCard: true,
        width: 960,
        canCancel: ['escape', 'outside']
      })
    },
    registerExpense() {
      this.$buefy.modal.open({
        parent: this,
        component: Expense,
        fullScreen: this.isMobile(),
        hasModalCard: true,
        width: 960,
        canCancel: ['escape', 'outside']
      })
    },
    cashOut() {
      this.$buefy.modal.open({
        parent: this,
        component: CashOut,
        fullScreen: this.isMobile(),
        hasModalCard: true,
        width: 960,
        canCancel: ['escape', 'outside']
      })
    }
  }
}
</script>
